import { TextField, Button, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import { Arr_SEFPages } from "../../../arrays/SEF/Arr_SEFPages";

function SEFChangePage({ Page, PageButtonStatus }) {
  //given Page, return the next page in the arrayIf non exists, return "Home"
  function getNextPage(Page) {
    //if Page==="PhotosInfo" then return { Link: "/Student", Name: "Home" }
    if (Page === "PhotosInfo") {
      return { Link: "/Student", Name: "Home" };
    }
    let index = Arr_SEFPages.findIndex((page) => page.Prop === Page);
    if (index === -1) {
      throw new Error("Page not found");
    }
    if (index === Arr_SEFPages.length - 1) {
      return { Link: "/Student", Name: "Home" };
    } else {
      return {
        Link: `/Student/${Arr_SEFPages[index + 1].link}/${localStorage.getItem(
          "Student_id"
        )}`,
        Name: Arr_SEFPages[index + 1].label,
      };
    }
  }

  //given Page, return the last page in the array. If non exists, return "Home"
  function getLastPage(Page) {
    let index = Arr_SEFPages.findIndex((page) => page.Prop === Page);
    if (index === -1) {
      throw new Error("Page not found");
    }
    if (index === 0) {
      return { Link: "/Student", Name: "Home" };
    } else {
      return {
        Link: `/Student/${Arr_SEFPages[index - 1].link}/${localStorage.getItem(
          "Student_id"
        )}`,
        Name: Arr_SEFPages[index - 1].label,
      };
    }
  }
  if (PageButtonStatus) {
    return (
      <div className="view-basic-info-buttons">
        <Button
          variant="contained"
          color="secondary"
          component={Link}
          to={getLastPage(Page).Link}
        >
          Go To {getLastPage(Page).Name}
        </Button>

        <Button
          variant="contained"
          color="secondary"
          component={Link}
          to={getNextPage(Page).Link}
        >
          Go To {getNextPage(Page).Name}
        </Button>
      </div>
    );
  } else {
    return <></>;
  }
}

export default SEFChangePage;
